import React, { useEffect, useState } from 'react';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import { getCurrentTeam, getListTeam } from '../../../apis/teams';
import { Breadcrumb, Button, Card, Table } from 'antd';
import { TeamOutlined, ApiOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const columns = [
  {
    title: 'Team Name',
    dataIndex: 'team',
    key: 'team',
    render: (value) => {
      return <div>{value.name}</div>
    }
  },
  {
    title: 'Your Role',
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: 'Services',
    dataIndex: 'Services',
    key: 'services',
    render: (value, row) => {
      return (
        <Link to={`/admin/teams/${row.team.id}/services`}>
          <Button type="primary">Details Services <ApiOutlined /></Button>
        </Link>)
    }
  },
  {
    title: 'Members',
    dataIndex: 'Members',
    key: 'members',
    render: (value, row) => {
      console.log(row);
      return (<Link to={`/admin/teams/${row.team.id}/members`}>
        <Button type="primary">
          Details Members <TeamOutlined />
        </Button>
      </Link>)
    }
  }
];

const otherColumns = [
  {
    title: 'Team Name',
    dataIndex: 'name',
    key: 'name',
    render: (value) => {
      console.log('--->', value)
      return <div>{value}</div>
    }
  },
  {
    title: 'Services',
    dataIndex: 'id',
    key: 'services',
    render: (value, row) => {
      return (
        <Link to={`/admin/teams/${value}/services`}>
          <Button type="primary">Services Detail <ApiOutlined /></Button>
        </Link>)
    }
  },
  {
    title: 'Members',
    dataIndex: 'id',
    key: 'members',
    render: (value, row) => {
      console.log(row);
      return (<Link to={`/admin/teams/${value}/members`}>
        <Button type="primary">
          Members Detail <TeamOutlined />
        </Button>
      </Link>)
    }
  }
]

const style = {
  tableToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0px'
  }
}

const ListTeam = ({ user }) => {
  const [currentTeam, setCurrentTeam] = useState([])

  const [otherTeam, setOtherTeam] = useState([])

  const isAdmin = (user && user.admin) || false;

  useEffect(() => {
    const fetchCurrentTeam = async () => {
      const { data: result } = await getCurrentTeam();
      setCurrentTeam(result);
    }

    const fetchOtherTeam = async () => {
      const result = await getListTeam();
      setOtherTeam(result);
    }

    if (!isAdmin) {
      fetchCurrentTeam();
    }
    fetchOtherTeam();
  }, [isAdmin])

  return (
    <AdminLayoutWrapper>
      <div style={{ padding: '0px 0px 16px 0px' }}>
        <Breadcrumb>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>
            Manage Team
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      {
        !isAdmin && (
          <Card>
            <div>
              <div style={style.tableToolbar}>
                <h3><b>Your Current Team</b></h3>
                {/* <div>
                  <Link to={`/admin/teams/create`}><Button type="primary">Create New Team</Button></Link>
                </div> */}
              </div>
              <Table
                dataSource={currentTeam}
                columns={columns}
              />
            </div>
          </Card>
        )
      }
      <Card>
        <div>
          <div style={style.tableToolbar}>
            {
              !isAdmin && <h3><b>Other Team</b></h3>
            }
            {
              isAdmin && (<>
                <h3><b>All Team</b></h3>
                <div>
                  <Link to={`/admin/teams/create`}><Button type="primary">Create New Team</Button></Link>
                </div>
              </>)
            }
          </div>
          <Table
            dataSource={otherTeam}
            columns={otherColumns}
          />
        </div>
      </Card>
    </AdminLayoutWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.app.user
  }
}

export default connect(mapStateToProps)(ListTeam);
